module.exports = __webpack_public_path__ + "static/media/logoBertelsmann.d8017e76.png";